import { render, staticRenderFns } from "./LapStokBarang.vue?vue&type=template&id=07b5646a"
import script from "./LapStokBarang.vue?vue&type=script&lang=js"
export * from "./LapStokBarang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports